/**
 * @ngdoc services
 * @memberof mercury.services
 * @name menu
 * @description Service to manage the application menu
 */
angular.module('mercury.services.applicationMenu')
.factory('applicationMenu', ["$http", "$q", "settings", function applicationMenuFactory($http, $q, settings) {

  var _menuPromises = {};
  var _activeCompanyId;

  // Helper to check if we've already got a request underway for a particular
  // companies menus, if not it'll initiate one.
  function _loadCompanyMenu(companyId) {
    if (!_menuPromises[companyId]) {
      _menuPromises[companyId] = $http.get(settings.mercHost + '/application-menu', {
        headers: {
          'x-loaded-company-id': companyId,
          'x-loaded-suppress-subscription-errors': '1'
        }
      });
    }
    return _menuPromises[companyId];
  }

  function setActiveCompany(companyId) {
    _activeCompanyId = companyId;
  }

  function getMenu(companyId) {
    companyId = companyId || _activeCompanyId;

    var deferred = $q.defer();

    if (!companyId) {
      deferred.reject();
    } else {
      _loadCompanyMenu(companyId).then(function(response) {
        deferred.resolve(response.data);
      });
    }

    return deferred.promise;
  }

  return {
    getMenu: getMenu,
    setActiveCompany: setActiveCompany
  };
}]);
